/**
 * A function that creates an element for the basic ProjectDescription
 * 
 * @memberof vef.viewer.loader
 * 
 * @param {object} options 
 * @param {Viewer} viewer 
 */
export function AddFilterButton(options, viewer) {
    const button = viewer.filters.createAddButton();
    button.id = options.id;

    viewer.addElement(options.id, button);

    viewer.filters.on("add", e => {
        viewer.appendElement(e.id, options.parentId, true);
        viewer.appendElement(options.id, options.parentId, true);
    });
}